import { useAuth } from "@/composables/useAuth";
import { useProfileStore } from "~~/stores/auth/profile";

export default defineNuxtRouteMiddleware(async (to) => {
  const { isAuthenticated } = useAuth();
  const profileStore = useProfileStore();

  const excludedRoutes = new Set([
    "/",
    "/profiles",
    "/logout",
    "/auth/not-allowed",
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
  ]);

  if (excludedRoutes.has(to.path)) return;

  if (!isAuthenticated.value) return;

  if (!profileStore.activeProfile) {
    return navigateTo("/profiles");
  }
});
